export default {
      id: "unit_dashboard__charge-usage",
      viewBox: "0 0 9 14",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__charge",
      toString: function () {
        return this.url;
      }
    }